import adminHttp from './admin-http';

export interface AdminLoginData {
  email: string;
  password: string;
}

export interface AdminCardAccessPayload {
  is_super_admin: boolean;
  can_view: boolean;
  can_view_pan: boolean;
  can_manage: boolean;
  can_freeze: boolean;
  can_view_funding: boolean;
  can_view_logs: boolean;
}

export interface AdminFinancialAccessPayload {
  can_view_treasury: boolean;
}

export interface AdminUser {
  id: number;
  name: string;
  email: string;
  role: string;
  permissions?: string[];
  page_permissions?: Record<string, string[]>;
  card_access?: AdminCardAccessPayload;
  financial_access?: AdminFinancialAccessPayload;
  avatar?: string;
  last_login_at?: string;
  login_count?: number;
}

export interface AdminAuthResponse {
  admin: AdminUser;
  token: string;
}

export const adminAuthApi = {
  login: async (data: AdminLoginData): Promise<AdminAuthResponse> => {
    const response = await adminHttp.post('/admin/adminLogin', data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await adminHttp.post('/admin/logout');
  },

  me: async (): Promise<AdminUser> => {
    const response = await adminHttp.get('/admin/me');
    return response.data;
  },
};
